import React from "react";
import { Button as NessieButton, NessieThemeProvider } from "@classdojo/web";
import { navigate } from "gatsby";
import { getRelativePath } from "@src/utils/routes";

export const Button = (
  props: {
    navigateTo?: string;
    onClick?: (val?: string) => void;
    children?: React.ReactNode;
    variant?: "primary" | "secondary";
    title?: string;
    rel?: string;
    kind?: string;
    marginBottom?: string;
  } & Omit<React.ComponentProps<typeof NessieButton>, "onClick" | "kind">,
) => {
  if (props.navigateTo) {
    const interceptAndNavigate = (event: { preventDefault: () => void }) => {
      props.onClick && props.onClick();
      event.preventDefault();
      // @ts-expect-error Type 'undefined' is not assignable to type 'string
      navigate(getRelativePath(props.navigateTo));
    };
    return (
      <NessieThemeProvider>
        {/* @ts-expect-error `kind` is incompatible */}
        <NessieButton {...props} href={getRelativePath(props.navigateTo)} onClick={interceptAndNavigate} />
      </NessieThemeProvider>
    );
  } else {
    return (
      <NessieThemeProvider>
        {/* @ts-expect-error Types of parameters 'val' and 'event' are incompatible.*/}
        <NessieButton {...props} />
      </NessieThemeProvider>
    );
  }
};
